import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiButton, NoddiSelectableBox, NoddiTextArea } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { tracking } from 'noddi-web';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const cancelledOptions = () => [
  {
    key: 'changed_plans',
    title: t`Changed my plans`,
    description: t`The time didn't work`
  },
  {
    key: 'price',
    title: t`Price`,
    description: t`Found a cheaper option`
  },
  {
    key: 'location',
    title: t`Location`,
    description: t`Location was not convenient`
  },
  {
    key: 'different_solution',
    title: t`Chose a different solution`,
    description: t`Used another service`
  },
  {
    key: 'other',
    title: t`Other`,
    description: t`Feel free to share more details`
  }
];

export const CancelledBooking = () => {
  const navigate = useNavigate();
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [otherReason, setOtherReason] = useState<string>('');

  const getCanSubmit = () => {
    if (selectedOptions.includes('other')) {
      return selectedOptions.length > 0 && !!otherReason;
    }
    return selectedOptions.length > 0;
  };

  function onSubmit() {
    tracking.track('booking_cancelled_feedback', {
      reasons: selectedOptions,
      otherReason
    });
    navigate(customerRoutes.cancelledBookingFeedback.getPath());
  }

  const toggleOption = (key: string) => {
    setSelectedOptions((prev) => {
      if (prev.includes(key)) {
        return prev.filter((option) => option !== key);
      } else {
        return [...prev, key];
      }
    });
  };

  return (
    <ContentWrapperCustomerApp
      hideBackButton
      showNewBookingButtonVariant='outline'
      title={t`Booking canceled`}
      showNewBookingButton
      subtitle={t`We're sorry you had to cancel! Would you like to share the reason with us?`}
    >
      <div className='flex flex-col gap-4'>
        <div>
          <span>
            <Trans>Select one or more</Trans>
          </span>
          <div className='flex flex-col gap-2'>
            {cancelledOptions().map((option) => {
              const isSelected = selectedOptions.includes(option.key);
              return (
                <NoddiSelectableBox
                  key={option.key}
                  isSelected={isSelected}
                  setIsSelected={() => toggleOption(option.key)}
                >
                  <div className='flex flex-col'>
                    <p className='font-semibold'>{option.title}</p>
                    <p>{option.description}</p>
                  </div>
                </NoddiSelectableBox>
              );
            })}
            {selectedOptions.includes('other') && (
              <div>
                <span>{t`Please elaborate`}</span>
                <NoddiTextArea
                  className='bg-white'
                  value={otherReason}
                  onChange={(event) => {
                    setOtherReason(event.target.value);
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <div className='flex justify-end'>
          <NoddiButton onClick={onSubmit} disabled={!getCanSubmit()}>{t`Send in feedback`}</NoddiButton>
        </div>
      </div>
    </ContentWrapperCustomerApp>
  );
};
